/* groovi-menu-drawer-fill.js — mobile menu drawer full-viewport fill (spec 1.11A).

   ROOT CAUSE (QA live @390×844): the mobile `.menu-drawer` is `position:fixed`
   but its nearest transformed ancestor is `.header-section`, which groovi-header.js
   drives with a DYNAMIC `translateY` (the floating hide/reveal). A transformed
   ancestor makes `position:fixed` resolve against IT, not the viewport (CLAUDE.md
   rule 10). So the drawer's visual top = the header's current translateY (measured
   +43 at rest, ~+70 revealed-solid, etc.), and a FIXED `height: calc(100dvh - 43px)`
   only reaches the fold when the offset is exactly 43 — in any other scroll state a
   34–44px strip of page shows below the drawer, and its 24px bottom-right radius can
   clip off-screen.

   FIX (drawer-scoped, header behaviour untouched): a full teleport to <body> was
   rejected — the drawer's show/hide relies on the `.menu-open > .menu-drawer`
   direct-child combinator, and header-drawer.js traps focus via
   `details.querySelector('.menu-drawer')`; moving the node out of the details breaks
   both. Instead we READ the header's live translateY and publish it as
   `--groovi-menu-drawer-fill`; the CSS uses `height: calc(100dvh - var(...))` so the
   drawer fills exactly to the viewport bottom in EVERY scroll state. A MutationObserver
   tracks any transform change while the drawer is open (belt-and-braces — scroll is
   usually locked while open). We never touch the header hide/reveal logic
   (behaviour-locked); this only compensates the drawer's own height. Mobile-only
   (matches the CSS block); on desktop the mega-menu is used, not this drawer. */
(function () {
  'use strict';

  var mobile = window.matchMedia('(max-width: 749px)');
  var details = document.getElementById('Details-menu-drawer-container');
  if (!details) return;

  var drawer = details.querySelector('.menu-drawer');
  var header = details.closest('.header-section');
  if (!drawer || !header) return;

  // translateY out of the computed transform matrix (matrix(a,b,c,d,tx,ty) or matrix3d).
  function headerOffset() {
    var t = getComputedStyle(header).transform;
    if (!t || t === 'none') return 0;
    var m = t.match(/matrix3d\(([^)]+)\)/);
    if (m) return parseFloat(m[1].split(',')[13]) || 0;
    m = t.match(/matrix\(([^)]+)\)/);
    if (m) return parseFloat(m[1].split(',')[5]) || 0;
    return 0;
  }

  function apply() {
    if (!mobile.matches || !details.hasAttribute('open')) return;
    var off = Math.max(0, headerOffset());
    drawer.style.setProperty('--groovi-menu-drawer-fill', off + 'px');
  }

  var observer = new MutationObserver(apply);

  details.addEventListener('toggle', function () {
    if (details.open) {
      observer.observe(header, { attributes: true, attributeFilter: ['style'] });
      apply();
    } else {
      observer.disconnect();
    }
  });

  mobile.addEventListener('change', apply);
})();
